import { inject } from "@angular/core";
import { AuthenticationService } from "../services/auth/authentication.service";

export const uploadModule = {
    application: 'application',
    agent: 'agent',
    university: 'university',
    courses: 'courses',
    profile: 'profile',
    users: 'users',
    application_statuses: 'application statuses',
    master_tool: 'master tool',
    university_contract: 'university contract',
    my_drive: 'my drive'
}

export const permissionEntity = { // don't change the spellings of below parameters
    modules: {
        dashboard: 'dashboard',
        dashboardmm: 'dashboardmm',
        dashboardrm: 'dashboardrm',
        dashboardurm: 'dashboardurm',
        agents: 'agents',
        approved_agent: 'approved agent',
        non_approved_agent: 'non approved agent',
        pending_bank_approval: 'pending bank approval',
        inactive_agent: 'inactive agent',
        counsellors: 'counsellors',
        applications: 'applications',
        notifications: 'notifications',
        university_cat_cpt_art: 'university cat/cpt/art',
        university: 'university',
        universities_entry_requirement: 'universities entry requirement',
        university_affiliate: 'university affiliate',
        universities_process_link: 'universities process link',
        universities_filter_master: 'universities filter master',
        university_filter_pg: 'university filter pg',
        university_filter_ug: 'university filter ug',
        courses: 'courses',
        options: 'options',
        filters: 'filters',
        art_received: 'art received',
        form_master_form: 'form',
        cat: 'cat',
        cat_all_case: 'cat all case',
        cat_my_case: 'cat my case',
        cat_change_case_owner: 'change case owner',
        cat_recieved: 'cat received',
        cpt: 'cpt',
        cpt_assign_application: 'cpt assign application',
        cpt_document_verification: 'cpt document verification',
        cpt_processed_application: 'cpt processed application',
        cct: 'cct',
        cct_interview_master: 'cct interview master',
        cct_interview_request: 'cct interview request',
        cct_quality_master: 'cct quality master',
        cct_view_interview: 'cct view interview',
        cct_assign_interview: 'cct assign interview',
        admin_notice_board: 'admin notice board',
        agent_notice_board: 'agent notice board',
        agent_webinar_board: 'agent webinar board',
        admin_master: 'admin master',
        mail_rule: 'mail rule',
        cabin: 'cabin',
        universitydeadline:'universitydeadline',
        loan:'loan',
        internaloptions:'internaloptions',
        company: 'company',
        aiInterview: 'ai interview',
        employee_designation: 'employee designation',
        job_role: 'job role',
        country: 'country',
        state: 'state',
        religions: 'religions',
        regions: 'regions',
        continents: 'continents',
        document_restrictions: 'document restrictions',
        email_master: 'email master',
        smtp: 'smtp',
        email_template: 'email template',
        email_events: 'email events',
        universities_email: 'universities e-mail',
        university_communication: 'university communication',
        mail_box: 'mail box',
        mmr_team: 'mmr team',
        store: 'store',
        sub_store: 'sub store',
        board: 'board',
        marksheet_verfication: 'marksheet verfication',
        student_previous_qualification: 'student previous qualification',
        application_primary_status: 'application primary status',
        application_auto_changes: 'application auto changes',
        application_secondary_status: 'application secondary status',
        application_communication_status: 'application communication status',
        application_internal_status: 'application internal status',
        link_builder: 'link builder',
        ip_details: 'ip tab',
        setting: 'setting',
        users: 'users',
        user_groups: 'user groups',
        agent_commission: 'agent commission',
        cas_master: 'cas master',
        agent_global_commission: 'agent-commission-global',
        university_contract: 'university contract',
        // invoice_finance: 'invoice-finance',
        // create_invoice: 'create-finance',
        profile: 'profile',
        update_password: 'update password',
        interview_type: 'interview type',
        interview_mode: 'interview mode',
        my_drive: 'my drive',
        // cas_master: 'cas master',
        confimation_awaited: 'confirmation awaited from university',
        ready_to_claim: 'ready to claim',
        support_chat: 'support chat',
        active_chat: 'active chat',
        support_chat_history: 'support chat history',
        notification: 'notification',
        automation: 'automation',
        dynamicFrom: 'dynamicfrom',
        automation_activity_log: 'automation activity log',
        automation_list: 'automation list',
        automation_option_list: 'automation option list',
        automation_log: 'automation-log',
        commission_console: 'agent commission crizac',
        referred_qc:'referred qc',
        qc_reports:'qc reports',
        payment_reports:'payment reports',
        call_logs: 'call logs',
        ai_interviewa_logs: 'aiinterview logs',
        bank_mail_details:'bank mail details',
        application_dashboard: 'application dashboard',
        africa_dashboard: 'africa dashboard',
        reports:'reports',
        archived:'archived',
        reschedule_interview_toggle : 'reschedule interview toggle',
        voucher: 'voucher',
        search_agent:'search agent',
        partners: 'partners',
        accommodation: 'accommodation',
        accomodation_commission: 'accomodation commission',
        training_hub: 'training hub',
        calendar_events: 'calendar event',
        ofiice_layout: 'office layout',
        dashboardCount: 'dashboardcount',
        password_manager: 'password manager',
        dynamicFromPreview: 'dynamicFromPreview',
        // report permission
        application_reports: 'application reports',
        application_flow_report: 'application flow report',
        application_received: 'application received',
        agent_rating_report: 'agent rating report',
        agent_not_given_application_report: 'agent not given application report',
        application_lifeline_report: 'application lifeline report',
        application_not_processed_report: 'application not processed report',
        application_ok_processing_report: 'application ok processing report',
        application_processed_report: 'application processed report',
        application_case_closed_report: 'application case closed report',
        application_offer_issued_report: 'application offer issued report',
        application_with_cas_report: 'application with cas report',
        cas_to_request_report: 'cas to request report',
        interview_report: 'interview report',
        payment_by_rm: 'payment by rm',
        pst_reports: 'pst reports',
        cpt_reports: 'cpt reports',
        timeline_of_application_reports: 'timeline of application reports',
        case_owner_reports: 'case owner reports',
        african_reports: 'african reports',
        processor_reports: 'processor reports',
        assessor_reports: 'assessor reports',
        year_year_comparison:'year year comparison',
        list_agent:'list agent'



    },
    access: {
        read: 'read',
        read_all: 'read all',
        create: 'create',
        edit: 'edit',
        delete: 'delete',
        filters: 'filters',
        uploads: 'uploads',
        downloads: 'downloads',
        mailrule: 'mailrule',
    }
}

export const sessionExpiryMinutes = 20; // Default timeout in minutes

